import React from 'react';
import { ROLES } from '../data/roles';
import { SECTIONS } from '../data/sections';
import { getOverallProgress } from '../utils/progress';
import './RoleScreen.css';

export default function RoleScreen({ state, onSelectRole, onContinue }) {
  return (
    <div className="page-content">
      <div className="card" style={{ marginTop: '0.75rem' }}>
        <div className="card-title">Select your role to get started</div>
        <div className="role-grid">
          {Object.entries(ROLES).map(([rk, r]) => {
            const totalSteps = r.sections.reduce((acc, k) => acc + (SECTIONS[k]?.checklist?.length || 0), 0);
            const { pct } = getOverallProgress(state.progress, rk);
            const selected = state.role === rk;

            return (
              <div
                key={rk}
                className={`role-card${selected ? ' role-card--selected' : ''}`}
                style={selected ? { borderColor: r.color, borderWidth: 2 } : {}}
                onClick={() => onSelectRole(rk)}
              >
                <div className="role-icon" style={{ background: r.light }}>
                  <i className={`ti ${r.icon}`} style={{ color: r.color, fontSize: 18 }} aria-hidden="true" />
                </div>
                <div className="role-name">{r.label}</div>
                <div className="role-meta">{r.sections.length} sections · {totalSteps} steps</div>
                {pct > 0 && (
                  <div className="pbar" style={{ marginTop: 6 }}>
                    <div className="pfill" style={{ width: `${pct}%`, background: r.color }} />
                  </div>
                )}
                {selected && (
                  <div className="role-selected-badge" style={{ color: r.color }}>
                    <i className="ti ti-check" style={{ fontSize: 11 }} aria-hidden="true" /> Selected
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {state.role && (
          <div style={{ marginTop: 14 }}>
            <button className="btn btn-primary" onClick={onContinue}>
              Open my dashboard
              <i className="ti ti-arrow-right" aria-hidden="true" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
